<ng-container *ngIf="user$ | async; let user">
  <td-layout-nav>
    <button mat-icon-button td-menu-button layout-align="start bottom" [tdLayoutToggle]="'true'">
      <mat-icon>menu</mat-icon>
    </button>
    <div td-menu-button layout-align="start bottom" class="logo-title" routerLink="/">
      <img src="dist/assets/images/gmr-logo-png.png" class="gmr-logo" />
      <span class="title">{{ title$ | async }}</span>
    </div>

    <div td-toolbar-content fxLayout fxLayoutAlign="start center" fxFlex>
      <div fxLayout fxLayoutAlign="end center" flex>
        <span fxFlex></span>
        <nav fxLayout>
          <ng-container *ngIf="user.isFlightLogUser">
            <a
              fxHide.xs
              mat-button
              class="push-right text-nodecoration"
              routerLink="/dashboards/pilot"
              [routerLinkActive]="['active']"
            >
              <mat-icon>web</mat-icon><span fxShow fxHide.sm>&nbsp;Dashboard</span>
            </a>
            <a
              fxHide.xs
              mat-button
              class="push-right text-nodecoration"
              routerLink="/flight-logs"
              [routerLinkActive]="['active']"
            >
              <mat-icon>flight_takeoff</mat-icon><span fxShow fxHide.sm>&nbsp;Flights</span>
            </a>
            <a
              fxHide.xs
              mat-button
              class="push-right text-nodecoration"
              routerLink="/reports"
              [routerLinkActive]="['active']"
            >
              <mat-icon>slow_motion_video</mat-icon><span fxShow fxHide.sm>&nbsp;Reports</span>
            </a>
            <a
              *ngIf="user.flightLogFeatures.dutyLogManagementForUser"
              fxHide.xs
              mat-button
              class="push-right text-nodecoration"
              routerLink="/duty-logs"
              [routerLinkActive]="['active']"
            >
              <mat-icon>history</mat-icon><span fxShow fxHide.sm>&nbsp;Duty History</span>
            </a>
            <a
              *ngIf="!user.flightLogFeatures.dutyLogManagementForUser"
              mat-button
              fxHide.xs
              class="push-right text-nodecoration"
              target="_blank"
              href="https://gh.goldenhourlive.com/admin/login.jsp"
            >
              <mat-icon>open_in_new</mat-icon><span fxShow fxHide.sm>&nbsp;Golden Hour</span>
            </a>
            <fl-duty-status-button
              *ngIf="showDutyStatusButton$ | async"
              fxHide.xs
            ></fl-duty-status-button>
          </ng-container>
          <button
            class="settings-menu-button push-right text-nodecoration"
            mat-button
            (click)="rightDrawer.toggle()"
            title="{{ user.fullName }}"
          >
            <span fxHide.xs>{{ user.fullName }}&nbsp;</span>
            <mat-icon>person</mat-icon>
          </button>
        </nav>
      </div>
    </div>
    <mat-sidenav-container fullscreen>
      <mat-sidenav #rightDrawer position="end" mode="side">
        <mat-card class="right-drawer-parent-card">
          <button mat-icon-button class="right-drawer-close-button" (click)="rightDrawer.close()">
            <mat-icon>close</mat-icon>
          </button>
          <mat-card-title-group>
            <mat-card-title
              >{{ user.fullName }}
              <span
                class="clear-impersonation"
                *ngIf="isImpersonating$ | async"
                (click)="clearImpersonation()"
                >(clear)</span
              >
            </mat-card-title>
            <mat-card-subtitle>{{ user.emailAddress }}</mat-card-subtitle>
            <mat-card-subtitle *ngIf="impersonatedByUser$ | async; let impersonatedByUser">
              <span *ngIf="isImpersonating$ | async"
                >Impersonated by: {{ impersonatedByUser.firstName }}
                {{ impersonatedByUser.lastName }}</span
              >
            </mat-card-subtitle>
          </mat-card-title-group>
          <mat-divider></mat-divider>
          <mat-nav-list dense>
            <a routerLink="/logout">
              <mat-list-item>
                <mat-icon>power_settings_new</mat-icon>
                <span mat-line>Logout</span>
              </mat-list-item>
            </a>
            <ng-container *ngIf="canImpersonate$ | async">
              <mat-list-item (click)="switchUser()">
                <mat-icon>people_alt</mat-icon>
                <span mat-line>Switch user</span>
              </mat-list-item>
            </ng-container>
          </mat-nav-list>
          <mat-divider></mat-divider> <mat-card-content> </mat-card-content>
        </mat-card>
      </mat-sidenav>
      <div
        class="right-drawer-content"
        *tdLoading="
          'default-layout';
          mode: 'indeterminate';
          type: 'circle';
          strategy: 'overlay';
          color: 'primary'
        "
      >
        <ng-container *ngIf="user.isFlightLogUser">
          <div
            fxLayout
            fxLayoutGap="10px"
            fxLayoutAlign="center center"
            *ngIf="currentDutyStatus$ | async; let ds"
            class="duty-status-bar"
          >
            <ng-container *ngIf="!ds.dutyLog.isActive; else onDuty">
              <strong title="Duty Status">OFF DUTY</strong>&nbsp;&mdash;
              <span title="Duty End Time">
                <mat-icon>hotel</mat-icon>&nbsp;{{
                  ds.dutyLog.dutyPeriodEndTime | momentDate: 'M/D HH:mm'
                }}
              </span>
              <span *ngIf="ds.restDurationDisplay$ | async; let restDuration" title="Rest Time">
                <mat-icon>av_timer</mat-icon>&nbsp;{{ restDuration }}
              </span>
            </ng-container>
            <ng-template #onDuty>
              <strong title="Duty Status">ON DUTY</strong>&nbsp;&mdash;
              <span *ngIf="ds.base?.name; let base" title="Base">
                <mat-icon>place</mat-icon>&nbsp;{{ base }}
              </span>
              <span *ngIf="ds.aircraft; let aircraft">
                <mat-icon>flight</mat-icon>&nbsp; <span title="Model">{{ aircraft.model }}</span> -
                <span title="Tail Number">{{ aircraft.tailNumber }}</span>
              </span>
              <span title="Duty Start Time">
                <mat-icon>schedule</mat-icon>&nbsp;{{
                  ds.dutyLog.dutyPeriodStartTime | momentDate: 'M/D HH:mm'
                }}
              </span>
              <span *ngIf="ds.dutyDurationDisplay$ | async; let dutyDuration" title="Time On Duty">
                <mat-icon>av_timer</mat-icon>&nbsp;{{ dutyDuration }}
              </span>
              <a
                *ngIf="canEdityDutyLog$ | async"
                mat-stroked-button
                routerLink="/duty-logs/duty-on"
              >
                <mat-icon>edit</mat-icon>&nbsp;Edit Shift</a
              >
              <ng-container *ngIf="canEditUnit$ | async">
                <a
                  *ngIf="ds.base?.id; let baseId"
                  mat-stroked-button
                  routerLink="/units/manage-unit"
                  [queryParams]="{ baseId: baseId }"
                >
                  <mat-icon>group</mat-icon>&nbsp;Manage Unit</a
                >
              </ng-container>
            </ng-template>
          </div>
        </ng-container>
        <fl-browser-notice></fl-browser-notice> <router-outlet></router-outlet>
      </div>
    </mat-sidenav-container>
  </td-layout-nav>
</ng-container>
